import React, { useState, useEffect } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useLocation } from "react-router-dom";
import AddEditPunchView from "./AddEditPunchView";
import {
  LOCATIONS,
  JOB_FAMILIES,
  DEFAULT_JOB_FAMILY,
  DEFAULT_ACTIVITY_GROUP,
  ACTIVITY_GROUP,
  EXCEPTIONS,
  DEFAULT_EXCEPTION,
  PUNCHES,
  SET_EMPTY,
  NO_EXCEPTION,
  MISSED_CLOCK_IN,
  MISSED_CLOCK_OUT,
  PROJECT,
  CLOCK_OUT,
  DEVICE_DETAILS,
} from "../../../../config";

import { CUSTOMER_SITE, LAST } from "config/CONSTANTS";

import {
  getJobProjectInfo,
  getActivityGroupByLanguage,
  getJobFamiliesByLanguage,
  getExceptionsByLanguage,
  getBuildings,
  getPunch,
  getUniqueID,
  getCustomerSite,
  getProjectsByActivityGroup,
  getActivityDetails,
} from "../../../../utils/punch";

import {
  ACTIVITIES,
  ALL_ACTIVITIES,
  REPORTS,
  REVIEW,
} from "../../../../navigation/CONSTANTS";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  ZERO,
  NEGATIVE,
  EQUAL,
  OVERLAPPING,
  POSITIVE,
  ADD,
  UPDATE,
  categoryPunch,
} from "pages/Punch/constants";
//backend
import {
  addPunch,
  updatePunch,
  getPunchData,
  getNewWorkerPunchRecords,
  setLastPunch,
  deleteIndividualPunch,
} from "../../../../services";
import {
  getActivityGroups,
  getExceptions,
  getJobFamilies,
  getLocations,
  getPunchLoading,
  getProjects,
} from "../../../../redux/actions/appActions";

import {
  isEmptyObject,
  getDistrictsByCountry,
  isDateValid,
  setDefaultValue,
} from "../../../../utils/index";
import {
  dateConfig,
  timeConfig,
  EDIT_STATUS,
  NEW_STATUS,
} from "../../../../config/index";
import { EMPTY } from "pages/AddWorker/config";
import { customerSiteAvailability, properCase } from "../../../../utils";

const minForStartDate = moment().day(-15).toDate();
const maxDate = moment().day(20).toDate();

export const AddEditPunchContainer = (props) => {
  const { t } = useTranslation();
  let defaultDistrict = [
    {
      value: -1,
      label: t("general.select1"),
      buildings: [{ value: -1, label: t("general.select2") }],
    },
  ];
  const defaultJobFamily = [{ label: t("general.select3"), value: -1 }];
  const defaultAG = [{ label: t("general.select4"), value: -1 }];
  const defaultActivity = [
    { label: t("other.lblSelectActivityName"), value: " " },
  ];
  const defaultProject = [{ label: "Select Project Name", value: " " }];
  const defaultLeave = [{ label: "Select Leave Type", value: " " }];
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const appConfig = useSelector((state) => state.appConfig);
  const user = useSelector((state) => state.user);
  const loggedInSupervisor = user.auth.user.workerId;
  const [worker, setWorker] = useState(location.state.worker);
  const lastPunchId =
    location.state.worker && location.state.worker.lastPunchId;
  const currentPunch = location.state.punch;
  console.log("this is current punch", currentPunch);
  let defaultEmployee = [
    {
      workerId: -1,
      firstName: t("general.selectEmployee"),
      lastName: "",
    },
  ];
  const workers =
    location.state.workers && defaultEmployee.concat(location.state.workers);
  // console.log("currentPunch data", "color: #99adcc", currentPunch);
  const [lastPunchDetails, setLastPunchDetails] = useState(null);
  const [pageTitle, setPageTitle] = useState(EMPTY);
  const [activityStartDate, setActivityStartDate] = useState(new Date());
  const [activityStartTime, setActivityStartTime] = useState(new Date());
  const [activityEndDate, setActivityEndDate] = useState(new Date());
  const [activityEndTime, setActivityEndTime] = useState(new Date());
  const [punch, setPunch] = useState(CLOCK_OUT);
  const [punchOptions, setPunchOptions] = useState(PUNCHES);
  const [district, setDistrict] = useState(defaultDistrict[0].value);
  const [building, setBuilding] = useState(
    defaultDistrict[0].buildings[0].value
  );
  const [buildingOptions, setBuildingOptions] = useState(
    defaultDistrict[0].buildings
  );
  const [jobFamily, setJobFamily] = useState(defaultJobFamily[0].value);
  const [activityGroup, setActivityGroup] = useState(defaultAG[0].value);
  let projectOptions = [];
  const [project, setProjectValue] = useState(defaultActivity[0].value);
  let isPersist = false;
  //remove hardcoded
  let districtOptions;
  districtOptions = defaultDistrict;
  let jobFamiliesOptions = getJobFamiliesByLanguage(
    i18n.language,
    JOB_FAMILIES
  );
  jobFamiliesOptions = [defaultJobFamily[0], ...jobFamiliesOptions];
  let activityGroupOptions = getActivityGroupByLanguage(
    i18n.language,
    ACTIVITY_GROUP
  );
  activityGroupOptions = [defaultAG[0], ...activityGroupOptions];
  let exceptionOptions = getExceptionsByLanguage(i18n.language, EXCEPTIONS);
  const [exception, setException] = useState(DEFAULT_EXCEPTION);
  // SPECIAL PROJECT DETAILS
  const [specialProjectDialog, setSpecialProjectDialog] = useState(false);
  const [specialProject, setSpecialProject] = useState(SET_EMPTY);
  const [isDisabledSpecialProjectOK, setIsDisabledSpecialProjectOK] =
    useState(true);
  const [jobProjectInfoLabel, setJobProjectInfoLabel] = useState(SET_EMPTY);

  const [jobProjectInfoVisible, setJobProjectInfoVisible] = useState(false);
  const [errProjectInfoEntry, setErrProjectInfoEntry] = useState(false);

  const [confirmationMsg, setConfirmationMsg] = useState(false);
  const [confirmationMsgText, setConfirmationMsgText] = useState(SET_EMPTY);

  const [disableSave, setDisableSave] = useState(false);

  const [confirmationTitleText, setConfirmationTitleText] =
    useState("Confirmation");

  const [allowNavigation, setAllowNavigation] = useState(true);
  const [customerSite, setCustomerSite] = useState(SET_EMPTY);
  const [errCustomerSite, setErrCustomerSite] = useState(false);
  const [customerSiteVisible, setCustomerSiteVisible] = useState(false);

  console.log("Container user", user, worker);

  // get all drop-down values from back end
  try {
    if (
      appConfig !== null &&
      appConfig.activityGroups !== null &&
      appConfig.jobFamilies !== null &&
      appConfig.exceptions !== null &&
      //appConfig.projects !== null &&
      (appConfig.locations !== null || appConfig.locations && appConfig.locations.length > 0)
    ) {
      // console.log('setting drop downs')
      // const deviceCountry = appConfig.deviceCountry.toLowerCase();

      // if (deviceCountry && appConfig.locations[deviceCountry])
      //   defaultDistrict = defaultDistrict.concat(
      //     appConfig.locations[deviceCountry]
      //   );

      districtOptions = defaultDistrict;
      const user = worker;
      if (user && user.countryCode && appConfig.locations) {
        const userCountry = user.countryCode.toLowerCase();

        if (
          user &&
          user.country === "testCountry" &&
          appConfig.locations.default &&
          appConfig.locations.default.length > 0
        ) {
          // isLocLoading = false;
          districtOptions = [defaultDistrict[0], ...appConfig.locations.default];
        } else {
          if (user && user.countryCode && appConfig.locations[userCountry]) {
            // isLocLoading = false;
            // if (
            //   user.countryCode.toLowerCase() !== deviceCountry.toLowerCase()
            // ) {
            districtOptions = defaultDistrict.concat(
              appConfig.locations[userCountry]
            );
            // }
          }
          if (user && user.alternateCountryCode && appConfig.locations[user.alternateCountryCode.toLowerCase()]) {
            const userAlternateCountry =
              user.alternateCountryCode.toLowerCase();
            // if (
            //   userAlternateCountry !== appConfig.deviceCountry.toLowerCase()
            // ) {
            districtOptions = [
              ...districtOptions,
              ...appConfig.locations[userAlternateCountry],
            ];
            // }
          }
        }
      }
      // districtOptions = appConfig.locations.default;
      // districtOptions = defaultDistrict.concat(districtOptions);
      // fallback
      // limit districts to user country
      // if (worker && worker.country) {
      //   districtOptions = getDistrictsByCountry(
      //     districtOptions,
      //     appConfig,
      //     worker.country,
      //     defaultDistrict
      //   );
      // }

      // if (lastPunchDetails === null && isEmptyObject(currentPunch)) {
      //   districtOptions = defaultDistrict.concat(districtOptions);
      // }

      exceptionOptions = getExceptionsByLanguage(
        i18n.language,
        appConfig.exceptions
      );
      if (lastPunchDetails === null && isEmptyObject(currentPunch)) {
        jobFamiliesOptions = getJobFamiliesByLanguage(
          i18n.language,
          appConfig.jobFamilies
        );
        jobFamiliesOptions = defaultJobFamily.concat(jobFamiliesOptions);
        activityGroupOptions = getActivityGroupByLanguage(
          i18n.language,
          appConfig.activityGroups
        );
        activityGroupOptions = defaultAG.concat(activityGroupOptions);
      } else {
        jobFamiliesOptions = getJobFamiliesByLanguage(
          i18n.language,
          appConfig.jobFamilies
        );
        activityGroupOptions = getActivityGroupByLanguage(
          i18n.language,
          appConfig.activityGroups
        );
      }
      if (appConfig.projects != null) {
        projectOptions = getProjectsByActivityGroup(
          appConfig.projects,
          activityGroup,
          defaultActivity,
          defaultProject,
          defaultLeave
        );
      }
    }
  } catch (error) {
    console.error("error in app config setting default", appConfig);
    // setting defaults
    districtOptions = defaultDistrict; //for showing select district option when nothing is there
    //removed below two lines for removal of hardcoded data when location is not present
    // districtOptions = LOCATIONS; // setting defaults
    // districtOptions = defaultDistrict.concat(districtOptions);
    jobFamiliesOptions = getJobFamiliesByLanguage(i18n.language, JOB_FAMILIES);
    activityGroupOptions = getActivityGroupByLanguage(
      i18n.language,
      ACTIVITY_GROUP
    );
  }

  const deleteHandler = (punch) => {
    deleteIndividualPunch(punch.id, loggedInSupervisor,punch.inLocalTS,punch.outLocalTS)
      .then((result) => {
        console.log("result:", result);
        if (result) {
          setConfirmationMsg(true);
          setConfirmationMsgText(t("pgReview.msgDeleteSuccess"));
          setConfirmationTitleText(t("pgPunch.tlConfirmation"));
        }
      })
      .catch((error) => {
        console.log("Error while individual delete:", error);
      });
  };

  // punch change is not in scope
  const punchChange = (event) => {
    // setPunch(event.target.value)
  };

  const activityStartDateChange = (date) => {
    setActivityStartDate(date);
    setActivityEndDate(date);
  };

  const activityStartTimeChange = (date) => {
    setActivityStartTime(date);
  };

  const activityEndDateChange = (date) => {
    setActivityEndDate(date);
  };

  const activityEndTimeChange = (date) => {
    setActivityEndTime(date);
  };

  const districtChange = (event) => {
    const district = event.target.value;
    setDistrict(district);
    setBuildingOptions(getBuildings(district, districtOptions));
    console.log("building options", buildingOptions, " current punch ", currentPunch)
    if (currentPunch && currentPunch.buildingId) {
      console.log("if part")
      setDefaultValue(
        buildingOptions,
        currentPunch.buildingId,
        buildingOptions[0].value,
        setBuilding
      );
    } else {
      console.log("else part")
      setBuilding(buildingOptions[0].value);
      console.log("building is", building, " and set as", buildingOptions[0].value)
    }
  };

  const buildingChange = (event) => {
    const building = event.target.value;
    setBuilding(building);
    customerSiteAvailability(
      building,
      customerSite,
      CUSTOMER_SITE,
      setCustomerSiteVisible,
      setCustomerSite,
      SET_EMPTY
    );
    // if (building === CUSTOMER_SITE) {
    //   setCustomerSiteVisible(true);
    // } else {
    //   setCustomerSiteVisible(false);
    //   setCustomerSite(SET_EMPTY);
    // }
  };

  const customerSiteChange = (event) => {
    const value = event.target.value;
    setCustomerSite(value);
    if (value.length === 0) {
      setErrCustomerSite(true);
    } else {
      setErrCustomerSite(false);
    }
  };

  const jobFamilyChange = (event) => {
    const selectedJobFamily = event.target.value;
    setJobFamily(selectedJobFamily);
  };

  const activityGroupChange = (event) => {
    const selectedActivityGroup = event.target.value;
    let j = activityGroupOptions.filter(
      (item) => item.value === selectedActivityGroup
    );
    const activityGroup = j[0].value;
    setActivityGroup(selectedActivityGroup);
    activityGroup === "Leave" && setJobFamily("Leave");
    if (activityGroup !== "Leave" && jobFamily === "Leave")
      setJobFamily(defaultJobFamily[0].value);

    // if (activityGroup === PROJECT) {
    //   setJobProjectInfoVisible(true);
    //   if (currentPunch && currentPunch.jobProjectInfo) {
    //     setSpecialProject(currentPunch.jobProjectInfo);
    //   }

    //   if (lastPunchDetails && lastPunchDetails.jobProjectInfo) {
    //     setSpecialProject(lastPunchDetails.jobProjectInfo);
    //   }
    // } else {
    //   setSpecialProject(SET_EMPTY);
    //   setJobProjectInfoVisible(false);
    // }
    projectOptions = getProjectsByActivityGroup(
      appConfig.projects,
      activityGroup,
      defaultActivity,
      defaultProject,
      defaultLeave
    );

    // setProjectValue(projectOptions[0].value)
  };

  const exceptionChange = (event) => {
    setException(event.target.value);
  };

  const employeeChange = (event, newValue) => {
    setWorker(newValue);
  };

  const handleChangeSpecialProject = (event) => {
    const value = event.target.value;
    setJobProjectInfoVisible(true);
    setJobProjectInfoLabel(value);
    // if (value.length === 0) {
    //   setIsDisabledSpecialProjectOK(true);
    //   setDisableSave(true);
    // } else {
    //   setIsDisabledSpecialProjectOK(false);
    //   setDisableSave(false);
    // }
    // setSpecialProject(value);
  };
  const okSpecialProjectDialog = () => {
    // setSpecialProjectDialog(false);
    // if (specialProject.length === 0) {
    //   setJobFamily(DEFAULT_JOB_FAMILY);
    // }
  };

  const cancelSpecialProjectDialog = () => {
    // setSpecialProjectDialog(false);
    // setSpecialProject(SET_EMPTY);
    // // if (activityGroup === PROJECT) {
    //   setActivityGroup(DEFAULT_ACTIVITY_GROUP);
    // }
  };

  const saveHandler = () => {
    setDisableSave(true);
    const actionBy = loggedInSupervisor;
    // let jobProjectInfo = getJobProjectInfo(specialProject);

    // if (!jobProjectInfoVisible) {
    //   jobProjectInfo = SET_EMPTY;
    // }

    // if (jobProjectInfoVisible && specialProject == SET_EMPTY) {
    //   setErrProjectInfoEntry(true);
    //   setDisableSave(false);
    //   console.log("can not add record as there are errors on form");
    //   return; // come out and prevent adding punch
    // }

    let customerSiteVal = getCustomerSite(customerSite);
    if (!customerSiteVisible) {
      customerSiteVal = SET_EMPTY;
    }

    if (customerSiteVisible && customerSite == SET_EMPTY) {
      setErrCustomerSite(true);
      setDisableSave(false);
      return;
    }

    const inTS = new Date(
      activityStartDate.getFullYear(),
      activityStartDate.getMonth(),
      activityStartDate.getDate(),
      activityStartTime.getHours(),
      activityStartTime.getMinutes(),
      activityStartTime.getSeconds(),
      activityStartTime.getMilliseconds()
    ).toISOString();

    const _inLocalTS = new Date(
      activityStartDate.getFullYear(),
      activityStartDate.getMonth(),
      activityStartDate.getDate(),
      activityStartTime.getHours(),
      activityStartTime.getMinutes(),
      activityStartTime.getSeconds(),
      activityStartTime.getMilliseconds()
    ).toString();

    const inLocalTS = moment(_inLocalTS).format(dateConfig.format4);

    const outTS = new Date(
      activityEndDate.getFullYear(),
      activityEndDate.getMonth(),
      activityEndDate.getDate(),
      activityEndTime.getHours(),
      activityEndTime.getMinutes(),
      activityEndTime.getSeconds(),
      activityEndTime.getMilliseconds()
    ).toISOString();

    const _outLocalTS = new Date(
      activityEndDate.getFullYear(),
      activityEndDate.getMonth(),
      activityEndDate.getDate(),
      activityEndTime.getHours(),
      activityEndTime.getMinutes(),
      activityEndTime.getSeconds(),
      activityEndTime.getMilliseconds()
    ).toString();

    const outLocalTS = moment(_outLocalTS).format(dateConfig.format4);
    const actionTS = new Date().toISOString();
    const version = getUniqueID();

    let activityName = punch;
    let isException = false;
    let exceptionName = SET_EMPTY;
    if (exception === NO_EXCEPTION) {
      isException = false;
    } else if (exception == MISSED_CLOCK_IN || exception === MISSED_CLOCK_OUT) {
      isException = true;
      exceptionName = exception;
    }

    if (isEmptyObject(currentPunch)) {
      // add new punch
      const status = NEW_STATUS;
      const newPunch = getPunch(
        activityGroup,
        activityName,
        building,
        district,
        customerSiteVal,
        exceptionName,
        isException,
        jobFamily,
        project,
        status,
        version,
        worker.workerId,
        actionTS,
        inTS,
        inLocalTS,
        outTS,
        outLocalTS,
        actionBy,
        DEVICE_DETAILS,
        categoryPunch
      );

      console.log("on save ", newPunch);
      let isPass = "";
      let action = "";
      const startdate = moment(newPunch.inLocalTS).format(dateConfig.format6);
      const endDate = moment(newPunch.outLocalTS).format(dateConfig.format6);
      const recentPunchIn = moment(newPunch.inLocalTS).format(
        dateConfig.format7
      );
      const recentPunchOut = moment(newPunch.outLocalTS).format(
        dateConfig.format7
      );
      const dayDiff = parseInt(
        moment
          .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
          .asMinutes()
      );
      console.log("DayDIff......." + dayDiff);
      getNewWorkerPunchRecords(
        newPunch.workerId,
        moment(startdate).subtract(1, "days").format(dateConfig.format4),
        moment(endDate).add(1, "days").format(dateConfig.format4)
      )
        .then((querySnapshot) => {
          console.log("querySnapshot....." + querySnapshot);
          if (querySnapshot != undefined && querySnapshot.length > 0) {
            querySnapshot.forEach((doc) => {
              if (doc.outLocalTS !== "") {
                doc.inLocalTS = moment(doc.inLocalTS).format(
                  dateConfig.format7
                );
                doc.outLocalTS = moment(doc.outLocalTS).format(
                  dateConfig.format7
                );
                if (recentPunchOut == recentPunchIn) {
                  isPass = ZERO;
                } else if (recentPunchOut < recentPunchIn) {
                  isPass = NEGATIVE;
                }
                // else if (dayDiff >= 1440) {
                //   isPass = DAY24HRS;
                // }
                else if (
                  recentPunchIn == doc.inLocalTS &&
                  recentPunchOut == doc.outLocalTS
                ) {
                  isPass = EQUAL;
                } else if (
                  (doc.inLocalTS > recentPunchIn &&
                    doc.inLocalTS < recentPunchOut) ||
                  (doc.outLocalTS > recentPunchIn &&
                    doc.outLocalTS < recentPunchOut) ||
                  (recentPunchIn > doc.inLocalTS &&
                    recentPunchIn < doc.outLocalTS) ||
                  (recentPunchOut > doc.inLocalTS &&
                    recentPunchOut < doc.outLocalTS)
                ) {
                  isPass = OVERLAPPING;
                } else {
                  if (
                    isPass != NEGATIVE &&
                    isPass != ZERO &&
                    // isPass != DAY24HRS &&
                    isPass != OVERLAPPING &&
                    isPass != EQUAL
                  ) {
                    isPass = POSITIVE;
                    action = ADD;
                  }
                }
              } else {
                doc.inLocalTS = moment(doc.inLocalTS).format(
                  dateConfig.format7
                );
                if (recentPunchOut == recentPunchIn) {
                  isPass = ZERO;
                } else if (recentPunchOut < recentPunchIn) {
                  isPass = NEGATIVE;
                }
                if (
                  recentPunchIn < doc.inLocalTS &&
                  recentPunchOut > doc.inLocalTS
                ) {
                  isPass = OVERLAPPING;
                } else if (recentPunchIn == doc.inLocalTS) {
                  isPass = EQUAL;
                } else {
                  if (
                    isPass != OVERLAPPING &&
                    isPass != EQUAL &&
                    isPass !== NEGATIVE &&
                    isPass !== ZERO
                  ) {
                    isPass = POSITIVE;
                    action = ADD;
                  }
                }
              }
            });
          } else {
            if (recentPunchOut == recentPunchIn) {
              isPass = ZERO;
            } else if (recentPunchOut < recentPunchIn) {
              isPass = NEGATIVE;
            }
            // else if (dayDiff >= 1440) {
            //   isPass = DAY24HRS;
            // }
            else {
              if (
                isPass != ZERO &&
                // isPass != DAY24HRS &&
                isPass != NEGATIVE
              ) {
                isPass = POSITIVE;
                action = ADD;
              }
            }
          }

          if (jobProjectInfoVisible) {
            newPunch.jobProjectInfo = jobProjectInfoLabel.trim();
          } else if (project == " ") {
            newPunch.jobProjectInfo = SET_EMPTY;
          }

          getValidateScenarios(isPass, action, newPunch, {});
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      // update old punch
      const status = EDIT_STATUS;

      const newPunch = getPunch(
        activityGroup,
        activityName,
        building,
        district,
        customerSiteVal,
        exceptionName,
        isException,
        jobFamily,
        project,
        status,
        version,
        worker.workerId,
        actionTS,
        inTS,
        inLocalTS,
        outTS,
        outLocalTS,
        actionBy,
        DEVICE_DETAILS,
        categoryPunch
      );

      console.log("on save ", newPunch);

      const startdate = moment(newPunch.inLocalTS).format(dateConfig.format6);
      const endDate = moment(newPunch.outLocalTS).format(dateConfig.format6);
      const recentPunchIn = moment(newPunch.inLocalTS).format(
        dateConfig.format7
      );
      const recentPunchOut = moment(newPunch.outLocalTS).format(
        dateConfig.format7
      );
      let isPass = "";
      let action = "";
      const dayDiff = parseInt(
        moment
          .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
          .asMinutes()
      );
      console.log("DayDIff......." + dayDiff);
      getNewWorkerPunchRecords(
        newPunch.workerId,
        moment(startdate).subtract(1, "days").format(dateConfig.format4),
        moment(endDate).add(1, "days").format(dateConfig.format4)
      )
        .then((querySnapshot) => {
          console.log("querySnapshot....." + querySnapshot);
          if (querySnapshot != undefined && querySnapshot.length > 0) {
            querySnapshot.forEach((doc) => {
              if (doc.outLocalTS !== "") {
                doc.inLocalTS = moment(doc.inLocalTS).format(
                  dateConfig.format7
                );
                doc.outLocalTS = moment(doc.outLocalTS).format(
                  dateConfig.format7
                );
                currentPunch.inLocalTS = moment(currentPunch.inLocalTS).format(
                  dateConfig.format7
                );
                currentPunch.outLocalTS = moment(
                  currentPunch.outLocalTS
                ).format(dateConfig.format7);
                if (recentPunchOut == recentPunchIn) {
                  isPass = ZERO;
                } else if (recentPunchOut < recentPunchIn) {
                  isPass = NEGATIVE;
                }
                // else if (dayDiff >= 1440) {
                //   isPass = DAY24HRS;
                // }
                else if (
                  currentPunch.id !== doc.id &&
                  recentPunchIn == doc.inLocalTS &&
                  recentPunchOut == doc.outLocalTS
                ) {
                  isPass = EQUAL;
                } else if (
                  currentPunch.inLocalTS != doc.inLocalTS &&
                  currentPunch.outLocalTS != doc.outLocalTS
                ) {
                  if (
                    (currentPunch.id != doc.id &&
                      doc.inLocalTS > recentPunchIn &&
                      doc.inLocalTS < recentPunchOut) ||
                    (doc.outLocalTS > recentPunchIn &&
                      doc.outLocalTS < recentPunchOut) ||
                    (recentPunchIn > doc.inLocalTS &&
                      recentPunchIn < doc.outLocalTS) ||
                    (recentPunchOut > doc.inLocalTS &&
                      recentPunchOut < doc.outLocalTS)
                  ) {
                    isPass = OVERLAPPING;
                  }
                } else {
                  if (
                    isPass != NEGATIVE &&
                    isPass != ZERO &&
                    // isPass != DAY24HRS &&
                    isPass != EQUAL &&
                    isPass != OVERLAPPING
                  ) {
                    isPass = POSITIVE;
                    action = UPDATE;
                  }
                }
              } else {
                doc.inLocalTS = moment(doc.inLocalTS).format(
                  dateConfig.format7
                );
                if (recentPunchOut == recentPunchIn) {
                  isPass = ZERO;
                } else if (
                  currentPunch.id != doc.id &&
                  recentPunchIn < doc.inLocalTS &&
                  recentPunchOut > doc.inLocalTS
                ) {
                  isPass = OVERLAPPING;
                } else if (recentPunchOut < recentPunchIn) {
                  isPass = NEGATIVE;
                }
                // else if (dayDiff >= 1440) {
                //   isPass = DAY24HRS;
                // }
                else {
                  if (isPass != OVERLAPPING && isPass != EQUAL) {
                    isPass = POSITIVE;
                    action = UPDATE;
                  }
                }
              }
            });
          } else {
            if (recentPunchOut == recentPunchIn) {
              isPass = ZERO;
            } else if (recentPunchOut < recentPunchIn) {
              isPass = NEGATIVE;
            }
            // else if (dayDiff >= 1440) {
            //   isPass = DAY24HRS;
            // }
            else {
              if (
                isPass != ZERO &&
                // isPass != DAY24HRS &&
                isPass != NEGATIVE
              ) {
                isPass = POSITIVE;
                action = UPDATE;
              }
            }
          }
          if (jobProjectInfoVisible) {
            newPunch.jobProjectInfo = jobProjectInfoLabel.trim();
          } else if (project == " ") {
            newPunch.jobProjectInfo = SET_EMPTY;
          }
          getValidateScenarios(isPass, action, newPunch, currentPunch);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const getValidateScenarios = (isPass, action, newPunch, currentPunch) => {
    console.log("getValidationScenarios called ..........");
    switch (isPass) {
      case NEGATIVE:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgNegative"),
          t("other.tlError"),
          false
        );
        break;
      case ZERO:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgZero"),
          t("other.tlError"),
          false
        );
        break;
      case EQUAL:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgEqual"),
          t("other.tlError"),
          false
        );
        break;
      // case DAY24HRS:
      //   setFlag(
      //     true,
      //     t("pgReview.dialogueMsgs.errMsgDay24Hrs"),
      //     "Error",
      //     false
      //   );
      //   break;
      case OVERLAPPING:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgOverlapping"),
          t("other.tlError"),
          false
        );
        break;
      case POSITIVE:
        console.log("POsitive" + isPass);
        if (action == ADD) {
          if (jobProjectInfoVisible) {
            newPunch.jobProjectInfo = jobProjectInfoLabel.trim();
          } else if (project == " ") {
            newPunch.jobProjectInfo = SET_EMPTY;
          }
          addPunch(newPunch, true, isPersist)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                t("pgPunch.tlConfirmation"),
                true
              );
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          if (jobProjectInfoVisible) {
            newPunch.jobProjectInfo = jobProjectInfoLabel.trim();
          } else if (project == " ") {
            newPunch.jobProjectInfo = SET_EMPTY;
          }
          if (lastPunchId && lastPunchId === currentPunch.id)
            isPersist = getActivityDetails(activityGroupOptions, activityGroup);
          updatePunch(currentPunch.id, newPunch, false, isPersist)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                t("pgPunch.tlConfirmation"),
                true
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
        break;
      default:
        console.log("default" + isPass);
        if (action == ADD) {
          if (jobProjectInfoVisible) {
            newPunch.jobProjectInfo = jobProjectInfoLabel.trim();
          } else if (project == " ") {
            newPunch.jobProjectInfo = SET_EMPTY;
          }
          addPunch(newPunch, true, isPersist)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                t("pgPunch.tlConfirmation"),
                true
              );
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          if (jobProjectInfoVisible) {
            newPunch.jobProjectInfo = jobProjectInfoLabel.trim();
          } else if (project == " ") {
            newPunch.jobProjectInfo = SET_EMPTY;
          }
          if (lastPunchId && lastPunchId === currentPunch.id)
            isPersist = getActivityDetails(activityGroupOptions, activityGroup);

          updatePunch(currentPunch.id, newPunch, false, isPersist)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                t("pgPunch.tlConfirmation"),
                true
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
        break;
    }
  };
  const setFlag = (msg, txt, titletxt, navigate) => {
    setConfirmationMsg(msg);
    setConfirmationMsgText(txt);
    setConfirmationTitleText(titletxt);
    setAllowNavigation(navigate);
  };
  const cancelHandler = () => {
    console.log("%c%s", "color: #aa00ff", cancelHandler);
    location.state.isAllPunch
      ? history.push(ALL_ACTIVITIES, { isAllPunchView: true })
      : location.state.isReport
        ? history.push(REPORTS, { isReportView: true })
        : // : history.push(ACTIVITIES);
        history.goBack();
  };

  const closeModalConfirmationMsg = () => {
    setConfirmationMsg(false);
    if (allowNavigation === true) {
      // history.push(REVIEW);
      location.state.isAllPunch
        ? history.push(ALL_ACTIVITIES, { isAllPunchView: true })
        : location.state.isReport
          ? history.push(REPORTS, { isReportView: true })
          : // : history.push(ACTIVITIES);
          history.goBack();
    } else {
      setDisableSave(false);
    }
  };
  const projectGroupHandler = (event) => {
    const projectGroup = event.target.value;
    let j = projectOptions.filter((item) => item.value === projectGroup);
    setJobProjectInfoVisible(false);
    //  setJobProjectInfoLabel(SET_EMPTY)
    setDefaultValue(
      projectOptions,
      projectGroup,
      projectOptions[0].value,
      setProjectValue
    );
  };
  const back = () => {
    // history.push(REVIEW);
    location.state.isAllPunch
      ? history.push(ALL_ACTIVITIES, { isAllPunchView: true })
      : location.state.isReport
        ? history.push(REPORTS, { isReportView: true })
        : history.goBack();
  };

  // Set building to first option if currentPunch (Edit Mode)
  // and last punch details (Add mode) is empty

  useEffect(() => {
    try {
      if (isEmptyObject(currentPunch) && isEmptyObject(lastPunchDetails)) {
        setBuilding(buildingOptions[0].value);
      }
      else {
        if (!isEmptyObject(currentPunch) && currentPunch.districtId !== district) {
          console.log("setting value from effect", defaultDistrict)
          setDefaultValue(
            buildingOptions,
            buildingOptions[0].label,
            buildingOptions[0].value,
            setBuilding
          );
        }
        else if (!isEmptyObject(currentPunch)) {
          setDefaultValue(
            buildingOptions,
            currentPunch.buildingId,
            buildingOptions[0].value,
            setBuilding
          );
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, [buildingOptions]);

  // fetching drop down values
  useEffect(() => {
    if (appConfig != null && appConfig.activityGroups == null) {
      dispatch(getPunchLoading());
      dispatch(getActivityGroups());
    }
    if (appConfig != null && appConfig.jobFamilies == null) {
      dispatch(getJobFamilies());
    }
    if (appConfig != null && appConfig.exceptions == null) {
      dispatch(getExceptions());
    }
    // if (appConfig != null && appConfig.locations == null) {
    //   dispatch(getLocations());
    // }
  }, []);

  useEffect(() => {
    if (worker && worker.workerId) {
      if (worker.country === "testCountry") {
        worker.countryCode = "testCountry";
      }
      if (
        worker.countryCode
        // worker.countryCode.toLowerCase() !==
        // appConfig.deviceCountry.toLowerCase()
      ) {
        dispatch(getLocations(worker.countryCode, worker.alternateCountryCode));
        //dispatch(getLocations(worker.alternateCountryCode));
      }
      //console.log("USER***",user)
    }
  }, [worker]);

  // console.log(districtOptions, );

  useEffect(() => {
    if (appConfig && !currentPunch) {
      setDistrict(districtOptions[0].value);
      setBuildingOptions(districtOptions[0].buildings);
    }
  }, [worker, appConfig]);

  // using currentPunch to populate UI fields
  useEffect(() => {
    if (!isEmptyObject(currentPunch)) {
      setPageTitle(properCase(t("pgAddEditPunchSupervisor.editPunch")));
      console.log("const currentPunch =", "color: #f200e2", currentPunch);
      // setPunch(currentPunch.activityName)
      setDefaultValue(
        districtOptions,
        currentPunch.districtId,
        districtOptions[0].value,
        setDistrict
      );
      //      setDistrict(currentPunch.districtId);

      let options = districtOptions.filter(
        (element) => element.value === currentPunch.districtId
      );
      // console.log('options', options)
      if (options.length > 0) {
        let allBuildingsOfDistrict = options[0].buildings;
        allBuildingsOfDistrict = defaultDistrict[0].buildings.concat(
          allBuildingsOfDistrict
        );
        setBuildingOptions(allBuildingsOfDistrict);
      }

      //setBuilding(currentPunch.buildingId);
      setDefaultValue(
        buildingOptions,
        currentPunch.buildingId,
        defaultDistrict[0].buildings[0].value,
        setBuilding
      );
      setJobFamily(currentPunch.jobName);
      //setJobProjectInfoLabel(currentPunch.jobProjectInfo);

      setActivityGroup(currentPunch.activityGroup);
      // projectOptions = getProjectsByActivityGroup(
      //   appConfig.projects,
      //   activityGroup,
      //   defaultActivity,
      //   defaultProject
      // );

      // setDefaultValue(
      //   projectOptions,
      //   currentPunch.jobProjectInfo,
      //   defaultActivity[0].value,
      //   setProjectValue
      // );
      // //setProjectValue(currentPunch.jobProjectInfo);
      let exceptionName = currentPunch.exceptionName.toLowerCase();
      if (exceptionName === SET_EMPTY) {
        exceptionName = NO_EXCEPTION;
      }
      setException(exceptionName);
      setActivityStartDate(new Date(currentPunch.inLocalTS));
      setActivityStartTime(new Date(currentPunch.inLocalTS));
      if (currentPunch.outLocalTS && currentPunch.outLocalTS !== SET_EMPTY) {
        setActivityEndDate(new Date(currentPunch.outLocalTS));
        setActivityEndTime(new Date(currentPunch.outLocalTS));
      }

      // check if jobProjectInfo available and show field
      // if (
      //   currentPunch.activityGroup == PROJECT &&
      //   (currentPunch.jobProjectInfo !== null ||
      //     currentPunch.jobProjectInfo !== undefined ||
      //     currentPunch.jobProjectInfo !== EMPTY)
      // ) {
      //   console.log(
      //     "currentPunch.jobProjectInfo  :",
      //     currentPunch.jobProjectInfo
      //   );

      //   setJobProjectInfoVisible(true);
      //   setSpecialProject(currentPunch.jobProjectInfo);
      // } else {
      //   setJobProjectInfoVisible(false);
      // }

      if (
        currentPunch.customerSite !== null &&
        currentPunch.customerSite !== undefined &&
        currentPunch.customerSite !== EMPTY
      ) {
        console.log("currentPunch.customerSite  :", currentPunch.customerSite);

        setCustomerSiteVisible(true);
        setCustomerSite(currentPunch.customerSite);
      } else {
        setCustomerSiteVisible(false);
      }
    } else {
      setPageTitle(properCase(t("pgAddEditPunchSupervisor.addPunch")));
      if (lastPunchId) {
        getPunchData(lastPunchId)
          .then((doc) => {
            let data = doc.data();
            if (data.status === "deleted") {
              // setLastPunch(data.workerId)
              //   .then((doc) => {
              //     console.log("LastPunch change Completed...", doc);
              //   })
              //   .catch((err) => {
              //     console.log("error changing lastPunch status!", err);
              //   });
              setLastPunchDetails(data);
            } else {
              setLastPunchDetails(data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, []);

  // Add mode - fetch last punch details
  useEffect(() => {
    // check if jobProjectInfo available and show field
    projectOptions = getProjectsByActivityGroup(
      appConfig.projects,
      activityGroup,
      defaultActivity,
      defaultProject
    );
    if (lastPunchDetails) {
      if (projectOptions.length <= 1) {
        setJobProjectInfoVisible(true);
        if (lastPunchDetails.jobProjectInfo) {
          setJobProjectInfoLabel(lastPunchDetails.jobProjectInfo);
        }
      } else {
        setJobProjectInfoVisible(false);
        setDefaultValue(
          projectOptions,
          lastPunchDetails.jobProjectInfo,
          defaultActivity[0].value,
          setProjectValue
        );
        //setJobProjectInfoLabel(SET_EMPTY);
      }
    } else {
      setJobProjectInfoVisible(false);
    }

    if (lastPunchDetails && lastPunchDetails.buildingId === CUSTOMER_SITE) {
      setCustomerSiteVisible(true);
      if (lastPunchDetails.customerSite) {
        setCustomerSite(lastPunchDetails.customerSite);
      }
    } else {
      setCustomerSiteVisible(false);
    }
  }, [lastPunchDetails]);

  useEffect(() => {
    if (worker && worker.country) {
      dispatch(getProjects(worker.country));
    }
  }, [worker]);

  // Add mode - set dropdown values based on last punch details information
  useEffect(() => {
    if (lastPunchDetails) {
      if (lastPunchDetails.districtId !== null && districtOptions) {
        let districtObj = districtOptions.filter(
          (item) => item.value === lastPunchDetails.districtId
        );
        if (districtObj.length > 0) {
          setDistrict(lastPunchDetails.districtId);
        } else {
          setDistrict(districtOptions[0].value);
        }
      }
      setJobFamily(lastPunchDetails.jobName);

      // setJobProjectInfoLabel(lastPunchDetails.jobProjectInfo);
      setActivityGroup(lastPunchDetails.activityGroup);
      // projectOptions = getProjectsByActivityGroup(
      //   appConfig.projects,
      //   activityGroup,
      //   defaultActivity,
      //   defaultProject
      // );
      // let j;
      // if (projectOptions.length > 1) {
      //   setJobProjectInfoVisible(false);
      //   j = projectOptions.find(
      //     (item) => lastPunchDetails.jobProjectInfo === item.value
      //   );
      //   if (j && j.label) {
      //     setProjectValue(lastPunchDetails.jobProjectInfo);
      //   }
      // } else {
      //   setJobProjectInfoVisible(true);
      //   setJobProjectInfoLabel(lastPunchDetails.jobProjectInfo);
      // }

      let buildings = getBuildings(
        lastPunchDetails.districtId,
        districtOptions
      );
      //      buildings=defaultDistrict[0].buildings.concat(buildings);
      let i;
      if (buildings) {
        setBuildingOptions(buildings);
        i = buildings.find(
          (item) => lastPunchDetails.buildingId === item.value
        );
      } else {
        setBuildingOptions(districtOptions[0].buildings);
      }
      let building;
      if (i && i.label) {
        building = lastPunchDetails.buildingId;
        setBuilding(building);
      }
      setCustomerSite(
        lastPunchDetails.customerSite
          ? lastPunchDetails.customerSite
          : SET_EMPTY
      );
    }
  }, [lastPunchDetails]);

  useEffect(() => {
    // if (currentPunch && currentPunch.activityGroup == PROJECT) {
    //   setJobProjectInfoVisible(true);
    //   if (currentPunch.jobProjectInfo) {
    //     setSpecialProject(currentPunch.jobProjectInfo);
    //   }
    // }
    if (currentPunch && currentPunch.buildingId === CUSTOMER_SITE) {
      setCustomerSiteVisible(true);
      if (currentPunch.customerSite) {
        setCustomerSite(currentPunch.customerSite);
      }
    } else {
      setCustomerSiteVisible(false);
    }
  }, [currentPunch]);

  // useEffect(() => {
  //   if (specialProject.length > 0) {
  //     setErrProjectInfoEntry(false);
  //   } else {
  //     setErrProjectInfoEntry(true);
  //   }
  // }, [specialProject]);

  // for user who is recently registered and no lastPunch details
  useEffect(() => {
    // disable save  button as user need to provide input

    if (lastPunchDetails === undefined || lastPunchDetails === null) {
      setDisableSave(true);
    }

    // fetch Day from Start Date
    if (activityStartDate !== null && activityEndDate !== null) {
      let startDay = new Date(
        activityStartDate.getFullYear(),
        activityStartDate.getMonth(),
        activityStartDate.getDate()
      );

      // fetch Day from End Date
      let endDay = new Date(
        activityEndDate.getFullYear(),
        activityEndDate.getMonth(),
        activityEndDate.getDate()
      );
      // enable save button if user changes all inputs
      if (
        district !== -1 &&
        building !== -1 &&
        jobFamily !== -1 &&
        activityGroup !== -1 &&
        worker &&
        worker.workerId &&
        worker.workerId !== -1 &&
        isDateValid(activityStartTime) &&
        isDateValid(activityEndTime) &&
        isDateValid(activityStartDate) &&
        isDateValid(activityEndDate) &&
        !(activityStartDate < minForStartDate || activityStartDate > maxDate) &&
        !(endDay < startDay || activityEndDate > maxDate)
      ) {
        setDisableSave(false);
      } else {
        setDisableSave(true);
      }
    }
  }, [
    district,
    building,
    jobFamily,
    activityGroup,
    worker,
    specialProject,
    activityStartDate,
    activityStartTime,
    activityEndDate,
    activityEndTime,
  ]);

  let [currentDay, setcurrentDay] = useState(null);
  let [currentTime, setCurrentTime] = useState(null);

  // useEffect(() => {

  //   let startDay = moment(activityStartDate).format(dateConfig.format3).toString();
  //   let startTime = moment(activityStartTime).format(timeConfig.format3).toString();

  //   let endDay = moment(activityEndDate).format(dateConfig.format3).toString();
  //   let endTime = moment(activityEndTime).format(timeConfig.format3).toString();

  //   if(!isEmptyObject(currentPunch))
  //    {

  //     let exceptionName = NO_EXCEPTION;
  //       console.log("jobProjectInfoLabel::::",jobProjectInfoLabel);
  //       console.log("project::::",project);
  //       console.log("currentPunch::::",currentPunch);
  //       console.log("jobProjectInfo::::",currentPunch.jobProjectInfo);
  //       console.log("jobProjectInfoVisible:",jobProjectInfoVisible);
  //       console.log("length:",projectOptions.length);
  //       if(currentPunch.exceptionName) exceptionName = currentPunch.exceptionName;

  //      if(currentPunch.endDate){
  //       setcurrentDay(currentPunch.endDate)
  //      }else if(currentPunch.outLocalTS){
  //       setcurrentDay(moment(currentPunch.outLocalTS).format(dateConfig.format3).toString())
  //      }
  //      if(currentPunch.endTime){
  //       setCurrentTime(currentPunch.endTime)
  //      }else if(currentPunch.outLocalTS){
  //       setCurrentTime(moment(currentPunch.outLocalTS).format(timeConfig.format3).toString())
  //      }

  //      let inLocalTS = moment(currentPunch.inLocalTS).format(dateConfig.format3).toString();

  //      let intime = moment(currentPunch.inLocalTS).format(timeConfig.format3).toString();

  //      if (customerSiteVisible && customerSite == EMPTY) {
  //         setErrCustomerSite(true);
  //         setDisableSave(true);
  //       }

  //       else if(district == -1 ||
  //         building == -1 ||
  //         jobFamily == -1 ||
  //         activityGroup == -1 ||
  //         worker.workerId == -1 ||
  //         !isDateValid(activityStartTime) ||
  //         !isDateValid(activityEndTime) ||
  //         !isDateValid(activityStartDate) ||
  //         !isDateValid(activityEndDate) ||
  //         (activityStartDate < minForStartDate || activityStartDate > maxDate) ||
  //          (endDay < startDay || activityEndDate > maxDate)

  //         )

  //         {
  //           setDisableSave(true);
  //       }
  //   else if (currentPunch.activityGroup === activityGroup &&
  //         currentPunch.jobName === jobFamily  &&
  //         currentPunch.buildingId === building &&
  //         ((customerSiteVisible && customerSite  && currentPunch.districtId === district && currentPunch.customerSite === customerSite) || (currentPunch.districtId === district && !customerSiteVisible)) &&
  //         intime === startTime &&
  //         inLocalTS === startDay &&
  //         currentDay && endDay === currentDay &&
  //         currentTime && endTime === currentTime &&
  //          exceptionName === exception   &&
  //           projectOptions.length > 1 ? currentPunch.jobProjectInfo && currentPunch.jobProjectInfo === project : jobProjectInfoVisible===true &&  currentPunch.jobProjectInfo && currentPunch.jobProjectInfo === jobProjectInfoLabel
  //         // jobProjectInfoVisible ===true && currentPunch.jobProjectInfo && currentPunch.jobProjectInfo === jobProjectInfoLabel
  //         // currentPunch.jobProjectInfo && (project && currentPunch.jobProjectInfo === project || currentPunch.jobProjectInfo === jobProjectInfoLabel)
  //         //projectOptions.length > 1 && currentPunch.jobProjectInfo ? (currentPunch.jobProjectInfo === jobProjectInfoLabel ): (currentPunch.jobProjectInfo  && currentPunch.jobProjectInfo === project)
  //       ){
  //         setDisableSave(true);
  //       }
  //       else{
  //         setDisableSave(false);
  //       }

  //     }

  // },[district,
  //   building,
  //   jobFamily,
  //   activityGroup,
  //   worker,
  //   specialProject,
  //   activityStartDate,
  //   activityStartTime,
  //   activityEndDate,
  //   activityEndTime,
  //   currentPunch,
  //   customerSite,
  //   exception,
  //   project,
  //   jobProjectInfoLabel,

  // ]);

  useEffect(() => {
    customerSiteAvailability(
      building,
      customerSite,
      CUSTOMER_SITE,
      setCustomerSiteVisible,
      setCustomerSite,
      SET_EMPTY
    );
  }, [building]);

  useEffect(() => {
    if (appConfig.projects) {
      projectOptions = getProjectsByActivityGroup(
        appConfig.projects,
        activityGroup,
        defaultActivity,
        defaultProject,
        defaultLeave
      );
      let lastactivity = LAST + activityGroup;

      if (currentPunch) {
        if (currentPunch.activityGroup == activityGroup) {
          if (projectOptions.length <= 1) {
            setJobProjectInfoVisible(true);
            setJobProjectInfoLabel(currentPunch.jobProjectInfo);
            setProjectValue(defaultProject[0].value);
          } else {
            setJobProjectInfoLabel(SET_EMPTY);
            setJobProjectInfoVisible(false);
            setDefaultValue(
              projectOptions,
              currentPunch.jobProjectInfo,
              projectOptions[0].value,
              setProjectValue
            );
          }
        } else {
          if (projectOptions.length <= 1) {
            setJobProjectInfoVisible(true);
            if (worker && worker[lastactivity]) {
              setProjectValue(defaultProject[0].value);
              setJobProjectInfoLabel(worker[lastactivity]);
            } else {
              setProjectValue(defaultProject[0].value);
              setJobProjectInfoLabel(SET_EMPTY);
            }
          } else {
            setJobProjectInfoLabel(SET_EMPTY);
            setJobProjectInfoVisible(false);
            if (worker && worker[lastactivity]) {
              setDefaultValue(
                projectOptions,
                worker[lastactivity],
                projectOptions[0].value,
                setProjectValue
              );
            } else {
              setProjectValue(defaultProject[0].value);
            }
          }
        }
      } else if (worker && worker[lastactivity]) {
        if (projectOptions.length <= 1) {
          setJobProjectInfoVisible(true);
          setJobProjectInfoLabel(worker[lastactivity]);
          setProjectValue(defaultProject[0].value);
        } else {
          setJobProjectInfoLabel(SET_EMPTY);
          setJobProjectInfoVisible(false);
          setDefaultValue(
            projectOptions,
            worker[lastactivity],
            projectOptions[0].value,
            setProjectValue
          );
        }
      } else {
        if (projectOptions.length <= 1) {
          setJobProjectInfoVisible(true);
          setJobProjectInfoLabel(SET_EMPTY);
          setProjectValue(defaultProject[0].value);
        } else {
          setJobProjectInfoVisible(false);
          setJobProjectInfoLabel(SET_EMPTY);
          setProjectValue(defaultActivity[0].value);
        }
      }
    }
  }, [currentPunch, worker, activityGroup, appConfig.projects]);

  useEffect(() => {
    projectOptions = getProjectsByActivityGroup(
      appConfig.projects,
      activityGroup,
      defaultActivity,
      defaultProject,
      defaultLeave
    );
  }, [lastPunchDetails, activityGroup]);

  useEffect(() => {
    if (currentPunch !== null && currentPunch.customerSite !== EMPTY) {
      setCustomerSite(currentPunch.customerSite);
    }
  }, [currentPunch]);

  return (
    <AddEditPunchView
      lastPunch={lastPunchDetails}
      currentPunch={currentPunch}
      deleteHandler={deleteHandler}
      pageTitle={pageTitle}
      user={worker}
      back={back}
      punchChange={punchChange}
      activityStartDate={activityStartDate}
      activityStartTime={activityStartTime}
      activityStartDateChange={activityStartDateChange}
      activityStartTimeChange={activityStartTimeChange}
      activityEndDate={activityEndDate}
      activityEndTime={activityEndTime}
      activityEndDateChange={activityEndDateChange}
      activityEndTimeChange={activityEndTimeChange}
      districtOptions={districtOptions}
      district={district}
      districtChange={districtChange}
      building={building}
      buildingOptions={buildingOptions}
      buildingChange={buildingChange}
      jobFamiliesOptions={jobFamiliesOptions}
      jobFamily={jobFamily}
      jobFamilyChange={jobFamilyChange}
      activityGroupOptions={activityGroupOptions}
      activityGroup={activityGroup}
      activityGroupChange={activityGroupChange}
      exceptionOptions={exceptionOptions}
      exception={exception}
      exceptionChange={exceptionChange}
      punch={punch}
      punchOptions={punchOptions}
      cancelHandler={cancelHandler}
      saveHandler={saveHandler}
      specialProjectDialog={specialProjectDialog}
      specialProject={specialProject}
      handleChangeSpecialProject={handleChangeSpecialProject}
      isDisabledSpecialProjectOK={isDisabledSpecialProjectOK}
      okSpecialProjectDialog={okSpecialProjectDialog}
      cancelSpecialProjectDialog={cancelSpecialProjectDialog}
      jobProjectInfoLabel={jobProjectInfoLabel}
      jobProjectInfoVisible={jobProjectInfoVisible}
      errProjectInfoEntry={errProjectInfoEntry}
      confirmationMsg={confirmationMsg}
      closeModalConfirmationMsg={closeModalConfirmationMsg}
      confirmationMsgText={confirmationMsgText}
      confirmationTitleText={confirmationTitleText}
      allowNavigation={allowNavigation}
      disableSave={disableSave}
      customerSite={customerSite}
      errCustomerSite={errCustomerSite}
      customerSiteVisible={customerSiteVisible}
      customerSiteChange={customerSiteChange}
      workers={workers}
      employeeChange={employeeChange}
      project={project}
      projectOptions={projectOptions}
      projectGroupHandler={projectGroupHandler}
    />
  );
};

AddEditPunchContainer.propTypes = {};

export default AddEditPunchContainer;
